import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { cancelMsg, confirmMsg, t } from '../../../common/i18n/index.js';

interface DeleteScheduledChangeDialogProps {
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteScheduledChangeDialog = ({ onClose, onConfirm }: DeleteScheduledChangeDialogProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CL.Modal
      autoOpen
      onModalClose={onClose}
      size="s"
      heading={t.G9UR('Do you really want to delete scheduled change?')}
      content={t.O21N('You are about to delete a scheduled change request. The removal can not be undone.')}
      buttons={[
        <CL.Button color="link" key="btnCancel" onClick={onClose} disabled={isLoading}>
          {t.B2V1(cancelMsg)}
        </CL.Button>,
        <CL.Button color="primary" key="btnConfirm" onClick={handleConfirm} loading={isLoading}>
          {t.QVYK(confirmMsg)}
        </CL.Button>,
      ]}
    />
  );
};

interface PreventEditDialogProps {
  onClose: () => void;
}

export const PreventEditDialog = ({ onClose }: PreventEditDialogProps) => (
  <CL.Modal
    autoOpen
    onModalClose={onClose}
    size="s"
    heading={t.CXWM('This subscription has a scheduled change request')}
    content={t.PA2R('This subscription has a scheduled change request so editing is not possible')}
  />
);
